export const SAVE_VC_PROFILE = id => `SAVE_VC_PROFILE_${id}`;
export const REFRESH_PROFILES = id => `REFRESH_PROFILES_${id}`;
export const UPDATE_VC_PROFILE = id => `UPDATE_VC_PROFILE_${id}`;

export const saveVCProfile = (id, data) => ({ type: SAVE_VC_PROFILE(id), data });
export const refreshProfiles = vcId => ({ type: REFRESH_PROFILES(vcId) });
export const updateVcProfile = (id, data) => ({ type: UPDATE_VC_PROFILE(id), data });



// WEBPACK FOOTER //
// ./src/containers/VCProfile/actions.js